import {
  Box,
  Button,
  Checkbox,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  TableHead,
  TextField,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Dialog,
} from '@material-ui/core';
import { getUser } from '../../../helpers';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';
import React, { useContext, useState, useEffect } from 'react';
import { productsTableConfigMain } from '../../config';
// import { useHistory } from "react-router-dom";

// icons
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import WarningIcon from '@material-ui/icons/Warning';
import PrintIcon from '@material-ui/icons/Print';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

// dependencies
import {
  getProductDetails,
  updateRPO,
  deleteCostRecordsByProduct,
  deleteCostRecordsByCostId,
  setProductDiscontinued,
} from '../../../Actions';
import { AlertContext } from '../../../Context/AlertContextProvider';
import { AppContext } from '../../../Context/AppContextProvide';
import { formatDate, formatDttm } from '../../../Util/timezone';
import { chargeLineText, splitByType } from '../../../Util/freightCharges';
import { ProductsWithSearchContext } from '../../../Context/ProductsWithSearchContextProvider';
import { CalculationVisualizerContextProvider } from '../../../Context/CalculationVisualizerContextProvider';
import FlowModal from '../../Admin/CustomCalculations/FlowModal';

// style
import '../../styles/Row.css';

// cost disclaimer
const costDisclaimer = 'Call for price.';

// config
function Row (props) {
  const {
    product,
    isItemSelected,
    handleClick,
    duplicateFlag,
    onDuplicateClick,
    hasPrinted,
    // Opt-in: only pages that pass this get the discontinue controls, so adding
    // them to the product search page leaves the legacy product page untouched.
    allowDiscontinue,
    // Vendor freight/tariff charges resolved for this product (display-only) —
    // drives the truck indicator. Staff data: only rendered when cost is visible.
    freightCharges,
  } = props;
  const [productInfo, setProductInfo] = useState([]);
  const [open, setOpen] = useState(false);
  const labelId = `enhanced-table-checkbox-${product.product_uuid}`;
  const { handleAlertOpen, setMessageType, setMessage } =
    useContext(AlertContext);
  const { roleId, roleName, rolePrefix } = useContext(AppContext);
  const { updateProduct, setUpdateProduct, setGetProductsList } = useContext(
    ProductsWithSearchContext
  );
  const fontcolor = {
    style: { color: '#333' },
  };
  // Price-editing mode for the options table (shows the override column + the
  // bulk bar). Named for what it is \u2014 it used to be an inverted `disabled` flag.
  const [editingPrices, setEditingPrices] = useState(false);
  const [tempRPO] = useState({});
  // Value typed into "set all overrides to" \u2014 applied to every row on demand,
  // never saved on its own.
  const [bulkPrice, setBulkPrice] = useState('');
  const [user] = useState(getUser());
  const [alertOpen, setAlertOpen] = useState(false);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
  const [deleteProductUuid, setDeleteProductUuid] = useState('');
  const [selected, setSelected] = useState([]);
  const [ounceWeight, setOunceWeight] = useState(false);
  const [wearLayer, setWearLayer] = useState(false);
  const [thickness, setThickness] = useState(false);
  const [promoCost, setPromoCost] = useState(false);
  const [promoRetail, setPromoRetail] = useState(false);
  // Pending discontinue confirmation: { scope, costId, optionLabel } or null.
  const [confirmStatus, setConfirmStatus] = useState(null);
  const [statusBusy, setStatusBusy] = useState(false);
  // Price flow modal: cost_id of the option whose "?" was clicked, or null.
  const [calcFlowCostId, setCalcFlowCostId] = useState(null);
  // Freight & tariff charges dialog, opened from the truck icons.
  const [freightDialogOpen, setFreightDialogOpen] = useState(false);
  const today = new Date().toISOString().slice(0, 10);

  const isAdmin = user.access_type_cd === 'a';
  const isReadOnly = user.access_type_cd === 'ro';
  // Admins and read/write staff may discontinue; read-only staff and customers
  // may not. Gated by the page opting in via allowDiscontinue.
  const canDiscontinue =
    !!allowDiscontinue && ['a', 'rw'].includes(user.access_type_cd);
  // Cost is internal \u2014 hidden from customers and read-only staff.
  const showCost = !!user.user_id && !isReadOnly && user.access_type_cd !== 'c';
  // Price flow is admin/hidden-staff only \u2014 same gate as the product page, and
  // the visualizer endpoint enforces it server-side (adminMiddleware).
  const canSeeCalcFlow = !!user.user_id && (isAdmin || !!user.is_hidden);
  // The product counts as discontinued only when every option it shows is.
  const productDiscontinued =
    productInfo.length > 0 &&
    productInfo.every((option) => Number(option.discontinued) === 1);

  useEffect(() => {
    if (updateProduct !== undefined) {
      setOpen(false);
      setUpdateProduct(undefined);
    }
  }, [open, setUpdateProduct, updateProduct]);

  // const handleUpdate = (productId) => {
  //   history.push(`/product/${productId}`);
  // };

  // Loads (or reloads) the option rows shown in the expanded panel. Extracted from
  // handleOpen so a discontinue/reactivate can refresh the panel in place.
  const loadOptions = async (productId, roleId) => {
    const costArray = [];
    const priceArray = [];
    const data = await getProductDetails(productId, roleId);
    // Tolerate an empty payload rather than throwing — an empty options list is a
    // truer result than "Error retrieving data", and it keeps a successful
    // discontinue from being reported to the user as a failure.
    const options = data?.data?.data?.[0]?.options || [];
    setProductInfo(options);
    setPromoRetail(false);
    setPromoCost(false);
    options.forEach((result, index) => {
      costArray.push(result.promotion.cost);
      priceArray.push(result.promotion.retail_price);

      if (
        result.wear_layer !== '' &&
        result.wear_layer !== null &&
        result.wear_layer !== undefined
      ) {
        setWearLayer(true);
      }
      if (
        result.ounce_weight !== '' &&
        result.ounce_weight !== null &&
        result.ounce_weight !== undefined
      ) {
        setOunceWeight(true);
      }
      if (
        result.thickness !== '' &&
        result.thickness !== null &&
        result.thickness !== undefined
      ) {
        setThickness(true);
      }
      if (costArray.some((c) => c !== null) && user.access_type_cd !== 'ro') {
        setPromoCost(true);
      }
      if (
        result.promotion.retail_price !== null &&
        result.promotion.effective_start_date !== null &&
        result.promotion.effective_end_date !== null
      ) {
        setPromoRetail(true);
      }
    });
  };

  const handleOpen = async (productId, roleId) => {
    if (!open) {
      try {
        await loadOptions(productId, roleId);
      } catch (e) {
        setMessageType('error');
        setMessage('Error retrieving data');
        handleAlertOpen();
      }
    }
    setOpen(!open);
  };

  // Writes the change, then reloads the panel so the new state (and any date) comes
  // from the server rather than being guessed locally — `discontinued` is computed
  // from cost.effective_end, not stored.
  const applyStatusChange = async ({ scope, costId, discontinued }) => {
    setStatusBusy(true);
    try {
      await setProductDiscontinued({
        product_uuid: product.product_uuid,
        discontinued,
        cost_ids: costId ? [costId] : undefined,
      });
      await loadOptions(product.product_uuid, roleId);
      setMessageType('success');
      setMessage(
        scope === 'style'
          ? discontinued
            ? 'Style discontinued'
            : 'Style reactivated'
          : discontinued
          ? 'Option discontinued'
          : 'Option reactivated'
      );
    } catch (err) {
      setMessageType('error');
      setMessage(
        discontinued
          ? 'Something went wrong, failed to discontinue.'
          : 'Something went wrong, failed to reactivate.'
      );
    } finally {
      setStatusBusy(false);
      setConfirmStatus(null);
      handleAlertOpen();
    }
  };

  // Discontinuing takes products off the floor, so confirm it. Reactivating is
  // reversible and non-destructive — apply it straight away.
  const requestStatusChange = (payload) => {
    if (payload.discontinued) setConfirmStatus(payload);
    else applyStatusChange(payload);
  };

  // Stages one option's override. Values are collected in tempRPO and only sent
  // when the user saves, so nothing is written until then.
  const stageRPO = (value, cost_id) => {
    tempRPO[cost_id] = value;
    setProductInfo((rows) =>
      rows.map((x) =>
        x.cost_id === cost_id ? { ...x, retail_price_override: value } : x
      )
    );
  };

  const handleUpdateRPO = (event, cost_id) => {
    if (/[a-zA-z]/.test(event)) {
      console.log('NOT A NUMBER');
      return;
    }
    stageRPO(event, cost_id);
  };

  // Bulk: stage the same override on every option shown. Users can still edit
  // individual rows afterwards — nothing is saved until "Save Prices".
  const applyBulkPrice = () => {
    const value = bulkPrice.trim();
    if (!value || /[a-zA-z]/.test(value)) return;
    productInfo.forEach((option) => {
      tempRPO[option.cost_id] = value;
    });
    setProductInfo((rows) =>
      rows.map((x) => ({ ...x, retail_price_override: value }))
    );
  };

  // Bulk: blank every override. The API treats '' as "remove the override", so
  // these rows fall back to normal margin-based pricing once saved.
  const clearAllPrices = () => {
    productInfo.forEach((option) => {
      tempRPO[option.cost_id] = '';
    });
    setBulkPrice('');
    setProductInfo((rows) =>
      rows.map((x) => ({ ...x, retail_price_override: '' }))
    );
  };

  const startEditingPrices = () => {
    setBulkPrice('');
    setEditingPrices(true);
  };

  // Abandon staged edits and reload, so cancelling can't leave edited values on
  // screen as though they had been saved.
  const cancelEditingPrices = async () => {
    Object.keys(tempRPO).forEach((key) => delete tempRPO[key]);
    setBulkPrice('');
    setEditingPrices(false);
    try {
      await loadOptions(product.product_uuid, roleId);
    } catch (e) {
      /* leaving edit mode is what matters; the list refreshes on next expand */
    }
  };

  const handleSetRPO = async () => {
    const staged = Object.keys(tempRPO);
    setEditingPrices(false);
    // Nothing staged: an empty map would build an `IN ()` and error server-side.
    if (!staged.length) {
      setBulkPrice('');
      return;
    }
    try {
      await updateRPO(tempRPO);
      Object.keys(tempRPO).forEach((key) => delete tempRPO[key]);
      setBulkPrice('');
      setMessage(
        staged.length === 1
          ? 'Retail price override set'
          : `Retail price overrides set on ${staged.length} SKUs`
      );
      setMessageType('success');
      setUpdateProduct(1);
    } catch (err) {
      setMessage('Error updating retail price override');
      setMessageType('error');
    }
    handleAlertOpen();
  };

  const handleConfirmDelete = () => {
    selected.length > 0
      ? deleteCostRecordsByCostId(selected)
          .then(() => {
            setMessage('Product deleted');
            setMessageType('success');
            handleAlertOpen();
            handleDeleteAlertClose();
            setUpdateProduct(1);
            setSelected([]);
            setGetProductsList(true);
          })
          .catch((err) => {
            setMessage('Something went wrong, failed to delete product.');
            setMessageType('error');
            handleAlertOpen();
            handleDeleteAlertClose();
            console.log(err);
          })
      : deleteCostRecordsByProduct(deleteProductUuid)
          .then(() => {
            setMessage('Product deleted');
            setMessageType('success');
            handleAlertOpen();
            handleDeleteAlertClose();
            setUpdateProduct(1);
            setSelected([]);
            setGetProductsList(true);
          })
          .catch((err) => {
            setMessage('Something went wrong, failed to delete product.');
            setMessageType('error');
            handleAlertOpen();
            handleDeleteAlertClose();
            console.log(err);
          });
  };

  const handleCautionAlertOpen = (productUuid) => {
    setDeleteProductUuid(productUuid);
    setAlertOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleDeleteAlertClose = () => {
    setDeleteAlertOpen(false);
  };

  const handleDeleteAlertOpen = () => {
    setDeleteAlertOpen(true);
    setAlertOpen(false);
  };

  const handleProductSelect = (event, id) => {
    handleClick(event, id);
  };

  const handleDeleteSku = (event, id) => {
    const selectedIndex = selected.indexOf(id);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const alert = () => {
    return (
      <Dialog
        open={alertOpen}
        onClose={handleAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">DELETE PRODUCTS!</DialogTitle>
        <DialogContent>
          {selected.length > 0 ? (
            <DialogContentText id="alert-dialog-description">
              This will delete the selected SKUs!
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description">
              This will delete ALL SKUs associated with this product! (
              <span style={{ color: '#FF0000' }}>
                Any printed QR codes will no longer work
              </span>
              )
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            autoFocus={true}
            onClick={handleAlertClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleDeleteAlertOpen}
            style={{ color: 'red' }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const confirmDeleteAlert = () => {
    return (
      <Dialog
        open={deleteAlertOpen}
        onClose={handleDeleteAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">DELETE PRODUCTS!</DialogTitle>
        <DialogContent>
          {selected.length > 0 ? (
            <DialogContentText id="alert-dialog-description">
              Are you absolutely sure you want to delete the selected SKUs?
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description">
              Are you absolutely sure you want to delete{' '}
              <span style={{ color: '#FF0000' }}>ALL</span> SKUs associated with
              this product?
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            autoFocus={true}
            onClick={handleDeleteAlertClose}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmDelete}
            style={{ color: 'red' }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const discontinueConfirmAlert = () => {
    const isStyle = confirmStatus?.scope === 'style';
    return (
      <Dialog
        open={!!confirmStatus}
        onClose={() => setConfirmStatus(null)}
        aria-labelledby="discontinue-dialog-title"
        aria-describedby="discontinue-dialog-description"
      >
        <DialogTitle id="discontinue-dialog-title">
          {isStyle ? 'DISCONTINUE PRODUCT?' : 'DISCONTINUE OPTION?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="discontinue-dialog-description">
            {isStyle ? (
              <>
                This marks <b>every option</b> of{' '}
                {product.trade_name || product.style} as discontinued, effective
                today.
              </>
            ) : (
              <>
                This marks{' '}
                <b>{confirmStatus?.optionLabel || 'this option'}</b> as
                discontinued, effective today.
              </>
            )}
          </DialogContentText>
          <DialogContentText>
            Discontinued items still show in search, and you can reactivate them
            from this same panel.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            autoFocus={true}
            onClick={() => setConfirmStatus(null)}
            disabled={statusBusy}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => applyStatusChange(confirmStatus)}
            style={{ color: 'red' }}
            disabled={statusBusy}
          >
            {statusBusy ? 'Working…' : 'Discontinue'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const money = (value) =>
    Number(value) === 0.0 ? costDisclaimer : '$' + value;

  // Price column takes the role's name when the role uses a prefix. Computed here
  // rather than written back onto the shared column config — that was mutating
  // module state for every other row on the page.
  const priceLabel =
    roleName === undefined || Number(rolePrefix) === 0
      ? ' Price'
      : Number(rolePrefix) === 1
      ? roleName + ' Price'
      : 'Retail Price';

  // Promotions only display inside their active window.
  const promoCostActive = (o) =>
    o.promotion.effective_end_date > today &&
    o.promotion.effective_start_date < today;
  const promoRetailActive = (o) =>
    o.promotion.effective_end_date >= today &&
    o.promotion.effective_start_date <= today &&
    o.promotion.retail_price > 0;

  // FlowModal expects the v2 option shape (numeric prices, promotion_pricing);
  // the legacy rows here carry price strings and a `promotion` object — adapt.
  const toFlowOption = (o) => ({
    cost_id: o.cost_id,
    color_name: o.color_name,
    distributor: o.distributor,
    uom: o.uom,
    basis_cd: o.basis_cd,
    retail_price: o.retail_price != null ? parseFloat(o.retail_price) : null,
    is_promo_active: promoRetailActive(o),
    promotion_pricing: {
      retail_price:
        o.promotion?.retail_price != null ? parseFloat(o.promotion.retail_price) : null,
    },
    is_discontinued: Number(o.discontinued) === 1,
  });

  // ONE definition of the options table, used for both the header and the body,
  // so the two can't drift apart (they previously did — edit mode rendered more
  // body cells than headers). Attributes with no data anywhere in the product are
  // dropped, and the wide read-only columns step aside while editing prices.
  const buildOptionColumns = () => {
    const columns = [
      { id: 'product_sku', label: 'SKU', render: (o) => o.product_sku },
      { id: 'color_name', label: 'Color', render: (o) => o.color_name },
    ];

    if (showCost) {
      columns.push({ id: 'cost', label: 'Cost', render: (o) => money(o.cost) });
    }
    if (promoCost && !editingPrices) {
      columns.push({
        id: 'promo_cost',
        label: 'Promo Cost',
        render: (o) =>
          promoCostActive(o) && o.promotion.cost != null
            ? `$ ${o.promotion.cost}`
            : '',
      });
    }

    // Import-managed cost_override values beat every margin setting, so a
    // price that "ignores" the admin margin pages needs this caption to make
    // sense. Read-only — the rows are written by the price-file imports.
    const overrideCaption = (o) => {
      const ov = o.price_overrides;
      if (!ov) return null;
      const parts = [];
      if (ov.price != null) parts.push(`price $${ov.price}`);
      if (ov.margin != null) parts.push(`margin ${parseFloat(Number(ov.margin).toFixed(2))}%`);
      if (ov.cost != null) parts.push(`cost $${ov.cost}`);
      if (!parts.length) return null;
      return (
        <Typography
          variant="caption"
          display="block"
          style={{ color: '#FF682C' }}
          title="Set by a price-file import (cost_override); it beats the margins configured on the Cost Adjustments page."
        >
          Import override: {parts.join(', ')}
        </Typography>
      );
    };

    columns.push({
      id: 'retail_price',
      label: priceLabel,
      render: (o) => (
        <>
          <span style={{ whiteSpace: 'nowrap' }}>
            {money(o.retail_price)}
            {canSeeCalcFlow && o.cost_id != null ? (
              <IconButton
                size="small"
                aria-label="show price calculation"
                title="How was this price calculated?"
                onClick={() => setCalcFlowCostId(o.cost_id)}
                style={{ marginLeft: 4 }}
              >
                <HelpOutlineIcon fontSize="small" />
              </IconButton>
            ) : undefined}
            {showCost && freightCharges?.length ? (
              <IconButton
                size="small"
                aria-label="freight and tariff charges"
                title="Freight charges may apply"
                onClick={() => setFreightDialogOpen(true)}
                style={{ color: '#00897b', marginLeft: 2 }}
              >
                <LocalShippingIcon fontSize="small" />
              </IconButton>
            ) : undefined}
          </span>
          {canSeeCalcFlow ? overrideCaption(o) : null}
        </>
      ),
    });

    if (editingPrices) {
      columns.push({
        id: 'retail_price_override',
        label: 'Retail Price Override',
        render: (o) => (
          <>
            $
            <TextField
              className="text-field"
              inputProps={{ fontcolor, maxLength: 7 }}
              value={o.retail_price_override ? o.retail_price_override : ''}
              onChange={(event) =>
                handleUpdateRPO(event.target.value, o.cost_id)
              }
            />
          </>
        ),
      });
    }

    if (promoRetail && !editingPrices) {
      columns.push({
        id: 'promo_retail_price',
        label: 'Promo Price',
        minWidth: 190,
        render: (o) =>
          promoRetailActive(o) && o.promotion.retail_price != null
            ? `$ ${o.promotion.retail_price} - Ending ${o.promotion.effective_end_date}`
            : '',
      });
    }

    columns.push({
      id: 'selling_unit',
      label: 'Selling Unit',
      render: (o) => `${o.selling_unit_quantity || ''} ${o.selling_unit_uom || ''}`,
    });

    if (thickness && !editingPrices) {
      columns.push({ id: 'thickness', label: 'Thickness', render: (o) => o.thickness });
    }
    if (wearLayer && !editingPrices) {
      columns.push({ id: 'wear_layer', label: 'Wear Layer', render: (o) => o.wear_layer });
    }
    if (ounceWeight && !editingPrices) {
      columns.push({ id: 'ounce_weight', label: 'Ounce Weight', render: (o) => o.ounce_weight });
    }

    columns.push(
      { id: 'margin', label: 'Margin', render: (o) => o.margin },
      { id: 'uom', label: 'UOM', render: (o) => o.uom },
      { id: 'basis_cd', label: 'Basis', render: (o) => o.basis_cd },
      { id: 'fob_origin', label: 'FOB Origin', render: (o) => o.fob_origin },
      { id: 'distributor', label: 'Distributor', render: (o) => o.distributor },
      {
        id: 'last_modified_dttm',
        label: 'Last Modified Date/Time',
        render: (o) => formatDttm(o.last_modified_dttm, { fallback: 'Never' }),
      }
    );

    // Only admins can act on the selection, so only they get the checkboxes.
    if (isAdmin) {
      columns.push({
        id: 'delete',
        label: 'Delete',
        render: (o) => (
          <Checkbox
            onClick={(event) => handleDeleteSku(event.target.checked, o.cost_id)}
            checked={isSelected(o.cost_id)}
            inputProps={{ 'aria-labelledby': labelId }}
            className="row__checkbox"
          />
        ),
      });
    }

    columns.push({
      id: 'status',
      label: 'Status',
      render: (o) => renderOptionStatus(o),
    });

    return columns;
  };

  // Per-option discontinued state: always the indicator, plus the toggle for
  // users allowed to change it.
  const renderOptionStatus = (option) => {
    const isDiscontinued = Number(option.discontinued) === 1;
    return (
      <div style={{ whiteSpace: 'nowrap' }}>
        {isDiscontinued && (
          <Tooltip
            title={
              option.effective_end_date
                ? `Discontinued ${formatDate(option.effective_end_date, {
                    fallback: '',
                  })}`
                : 'Product Discontinued'
            }
          >
            <InfoIcon color="secondary" style={{ verticalAlign: 'middle' }} />
          </Tooltip>
        )}
        {canDiscontinue && (
          <Button
            size="small"
            variant="contained"
            className={
              isDiscontinued
                ? 'row__status-btn row__status-btn--reactivate'
                : 'row__status-btn'
            }
            style={{ marginLeft: 4 }}
            disabled={statusBusy}
            onClick={() =>
              requestStatusChange({
                scope: 'option',
                costId: option.cost_id,
                discontinued: !isDiscontinued,
                optionLabel: [option.color_name, option.product_sku]
                  .filter(Boolean)
                  .join(' — '),
              })
            }
          >
            {isDiscontinued ? 'Reactivate' : 'Discontinue'}
          </Button>
        )}
      </div>
    );
  };

  const optionColumns = buildOptionColumns();

  return (
    <React.Fragment>
      <TableRow
        className="row__table-row"
        hover
        tabIndex={-1}
        role="checkbox"
        aria-checked={isItemSelected}
        key={`${product.product_uuid}`}
      >
        <TableCell className="row__table-cell" padding="checkbox">
          <Checkbox
            onClick={(event) =>
              handleProductSelect(event, product.product_uuid)
            }
            checked={isItemSelected}
            inputProps={{ 'aria-labelledby': labelId }}
            className="row__checkbox"
          />
        </TableCell>
        <TableCell className="row__table-cell" style={{ whiteSpace: 'nowrap' }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => handleOpen(product.product_uuid, roleId)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
          {hasPrinted && (
            <Tooltip title="A QR code has been printed for this product">
              <IconButton size="small" style={{ color: '#3949ab', marginLeft: 2 }} disableRipple>
                <PrintIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {duplicateFlag && onDuplicateClick && (
            <Tooltip title={`Potential duplicate detected (${(Number(duplicateFlag.score) * 100).toFixed(0)}% match) — click to review`}>
              <IconButton
                size="small"
                onClick={(e) => { e.stopPropagation(); onDuplicateClick(duplicateFlag); }}
                style={{ color: '#f57c00', marginLeft: 2 }}
              >
                <WarningIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </TableCell>
        {productsTableConfigMain.map((column) => {
          const value = product[column.id];
          return (
            <TableCell className="row__table-cell" key={column.id}>
              {column.id === 'update' ? (
                <a
                  href={`/product/${product.product_uuid}`}
                  target="blank"
                  style={{ textDecoration: 'none' }}
                >
                  <Button
                    variant="contained"
                    className="product-view-button"
                    // onClick={() => handleUpdate(product.product_uuid)}
                  >
                    View
                  </Button>
                </a>
              ) : typeof column.id === 'string' && column.id.endsWith('_dttm') ? (
                formatDttm(value, { fallback: '' })
              ) : (
                value
              )}
            </TableCell>
          );
        })}
      </TableRow>
      <TableRow>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <TableCell
            className="row__table-cell"
            style={{ paddingBottom: 0, paddingTop: 0 }}
            colSpan={6}
          >
            <Box margin={1} style={{ width: '90vw', marginLeft: '4vw' }}>
              {/* One action bar: editing on the left, destructive on the right. */}
              <div className="row__panel-actions">
                {editingPrices ? (
                  <>
                    <Button
                      className="row__panel-btn row__panel-btn--positive"
                      variant="contained"
                      onClick={handleSetRPO}
                    >
                      Save Prices
                    </Button>
                    <Button
                      className="row__panel-btn row__panel-btn--muted"
                      variant="contained"
                      onClick={cancelEditingPrices}
                    >
                      Cancel
                    </Button>
                  </>
                ) : (
                  <Tooltip title="Set a retail price override per SKU, or one price across every SKU. Overrides replace all other margins.">
                    <Button
                      className="row__panel-btn"
                      variant="contained"
                      onClick={startEditingPrices}
                      disabled={isReadOnly || productInfo.length === 0}
                    >
                      Edit Prices
                    </Button>
                  </Tooltip>
                )}

                <span className="row__panel-actions-spacer" />

                {canDiscontinue && (
                  <Tooltip
                    title={
                      productDiscontinued
                        ? 'Bring every option of this product back to active'
                        : 'Mark every option of this product discontinued, effective today'
                    }
                  >
                    <Button
                      id="tour-discontinue-product"
                      className={
                        productDiscontinued
                          ? 'row__panel-btn row__panel-btn--positive'
                          : 'row__panel-btn'
                      }
                      variant="contained"
                      disabled={statusBusy || productInfo.length === 0}
                      onClick={() =>
                        requestStatusChange({
                          scope: 'style',
                          discontinued: !productDiscontinued,
                        })
                      }
                    >
                      {productDiscontinued
                        ? 'Reactivate Product'
                        : 'Discontinue Product'}
                    </Button>
                  </Tooltip>
                )}
                {isAdmin && (
                  <Button
                    className="row__panel-btn"
                    variant="contained"
                    style={{ color: '#FF0000' }}
                    onClick={() =>
                      handleCautionAlertOpen(
                        selected.length > 0
                          ? product.cost_id
                          : product.product_uuid
                      )
                    }
                  >
                    {selected.length > 0 ? 'Delete SKU' : 'Delete Product'}
                  </Button>
                )}
              </div>

              {editingPrices && (
                <div className="row__bulk-price">
                  <Typography variant="body2">Set all SKUs to $</Typography>
                  <TextField
                    className="row__bulk-price-field"
                    inputProps={{ maxLength: 7, 'aria-label': 'price for all SKUs' }}
                    value={bulkPrice}
                    onChange={(e) => {
                      if (!/[a-zA-z]/.test(e.target.value)) {
                        setBulkPrice(e.target.value);
                      }
                    }}
                  />
                  <Button
                    size="small"
                    variant="contained"
                    className="row__panel-btn"
                    onClick={applyBulkPrice}
                    disabled={!bulkPrice.trim()}
                  >
                    Apply to all
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    className="row__panel-btn row__panel-btn--muted"
                    onClick={clearAllPrices}
                  >
                    Clear all
                  </Button>
                  <span className="row__bulk-price-hint">
                    Fills every override below — adjust any row before saving. A
                    blank override falls back to normal margin pricing.
                  </span>
                </div>
              )}

              <Typography
                variant="h6"
                align="center"
                gutterBottom
                component="div"
              >
                Product Info
              </Typography>
              {product.selling_unit_quantity && (
                <Typography
                  variant="h6"
                  align="center"
                  gutterBottom
                  component="div"
                >
                  Sold In Quantities of {product.selling_unit_quantity}{' '}
                  {product.selling_unit_uom}
                </Typography>
              )}

              <Table size="small" aria-label="product options">
                <TableHead>
                  <TableRow>
                    {optionColumns.map((column) => (
                      <TableCell key={column.id} style={{ minWidth: column.minWidth }}>
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productInfo.map((option, i) => (
                    <TableRow
                      className="product-detail-table"
                      key={option.cost_id ?? i}
                    >
                      {optionColumns.map((column, colIndex) => (
                        <TableCell
                          key={column.id}
                          component={colIndex === 0 ? 'th' : undefined}
                          scope={colIndex === 0 ? 'row' : undefined}
                        >
                          {column.render(option)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </TableCell>
        </Collapse>
      </TableRow>
      {alert()}
      {confirmDeleteAlert()}
      {canDiscontinue && discontinueConfirmAlert()}
      {calcFlowCostId !== null ? (
        <CalculationVisualizerContextProvider>
          <FlowModal
            isOpen
            onClose={() => setCalcFlowCostId(null)}
            productUUID={product.product_uuid}
            roleId={roleId}
            options={productInfo.map(toFlowOption)}
            initialCostId={calcFlowCostId}
            user={user}
          />
        </CalculationVisualizerContextProvider>
      ) : undefined}

      {/* Freight & tariff charges behind the truck icons — same breakdown the
          product page dialog shows. Charges resolve per product, not per option. */}
      <Dialog open={freightDialogOpen} onClose={() => setFreightDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Freight &amp; Tariff Charges</DialogTitle>
        <DialogContent>
          {[
            { label: 'Freight', charges: splitByType(freightCharges).freight },
            { label: 'Tariffs', charges: splitByType(freightCharges).tariff },
          ].filter((group) => group.charges.length).map((group) => (
            <div key={group.label} style={{ marginBottom: 12 }}>
              <Typography variant="body2"><b>{group.label}</b></Typography>
              {group.charges.map((charge) => (
                <Typography variant="body2" key={charge.freight_tariff_rule_id}>
                  {chargeLineText(charge)}
                </Typography>
              ))}
            </div>
          ))}
          <Typography variant="caption" color="textSecondary">
            Vendor charges — not included in the price.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFreightDialogOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default Row;
